/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconArrowRight is deprecated and will be archived soon. Use IconArrowRight instead.
 */

export function Experimental__IconArrowRight(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path d='M9.102 2.628l-.652.758 4.211 3.62H2v.989h10.661L8.45 11.628l.653.758 5.664-4.888z'/><path fill='none' d='M0 0h16v16H0z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M12.862 5.112l-.654.757L18.155 11H4v1h14.153l-5.944 5.111.652.759 7.406-6.368z'/><path fill='none' d='M0 0h24v24H0z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M18.04 7.133l-.652.758 8.266 7.108H5.001v1h20.654l-8.268 7.134.654.758 9.726-8.394z'/>"
  }, {
    size: 48,
    svgContent: "<path fill='none' d='M48 0v48H0V0z'/><path d='M26.724 11.223l-1.307 1.513 11.892 10.263H7.001v2h30.305L25.419 35.221l1.304 1.517 14.81-12.737z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M37.081 15.218l-1.307 1.513L52.309 31H9v2h43.307L35.775 47.216l1.304 1.517 19.454-16.73z'/><path fill='none' d='M64 64H0V0h64z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M.116 8c0 .414.335.75.75.75h12.189l-3.67 3.67a.75.75 0 001.061 1.06L15.926 8l-5.48-5.48a.75.75 0 10-1.06 1.06l3.669 3.67H.865a.75.75 0 00-.75.75z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M1.808 12a1 1 0 001 1h15.97l-4.793 4.793a1 1 0 001.414 1.414L22.607 12l-7.208-7.207a1 1 0 10-1.414 1.414L18.778 11H2.808a1 1 0 00-1 1z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  var autoMirror = props.autoMirror || true;
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconArrowRight;